// src/pages/onboarding/ai-setup.tsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

/**
 * Simplified AI setup page that no longer asks for API keys
 * Instead, just redirects to ai-run to use the backend API
 */
const OnboardingApiSetupPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Immediately redirect to ai-run since we're using the backend API
    navigate("/onboarding/ai-run");
  }, [navigate]);

  // Show loading while redirecting
  return (
    <div className="min-h-screen bg-gradient-hero relative overflow-hidden">
      <div className="relative z-10 flex justify-center items-center min-h-screen">
        <div className="text-center space-y-4">
          <Loader2 className="h-8 w-8 animate-spin mx-auto" />
          <p className="text-lg text-muted-foreground">
            Setting up AI insights...
          </p>
        </div>
      </div>
    </div>
  );
};

export default OnboardingApiSetupPage;
